import React from "react";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify-icon/react";

const BackTopBar: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="back-topbar">
      <button
        type="button"
        className="back-topbar-button"
        onClick={() => navigate("/")}
      >
        <Icon icon="line-md:chevron-left" className="back-topbar-icon" />
        <span>Back</span>
      </button>
    </div>
  );
};

export default BackTopBar;
